var React = require('react');

function KpiIcon14 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M57.75,5.3V57.5H2.5V5.3H57.75m2.5-2.5H0V60H60.25V2.8Z","transform":"translate(0 0)","fill":"#23282c","key":0}),React.createElement("line",{"x1":"0.52","y1":"15.37","x2":"59.73","y2":"15.37","fill":"none","stroke":"#23282c","strokeMiterlimit":"10","strokeWidth":"2.5","key":1}),React.createElement("rect",{"x":"46.49","width":"2.62","height":"11.2","fill":"#23282c","key":2}),React.createElement("polygon",{"points":"40.55 28.29 38.65 26.39 26.23 38.81 21.6 34.19 19.7 36.09 24.33 40.71 24.32 40.73 26.21 42.62 26.23 42.61 26.24 42.62 28.14 40.73 28.13 40.71 40.55 28.29","fill":"#fc5a10","fillRule":"evenodd","key":3}),React.createElement("rect",{"x":"11.38","width":"2.62","height":"11.2","fill":"#23282c","key":4})]);
}

KpiIcon14.defaultProps = {"width":"21.26mm","height":"21.17mm","viewBox":"0 0 60.25 60"};

module.exports = KpiIcon14;

KpiIcon14.default = KpiIcon14;
